import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  Order,
  OrderByNumberParams,
  OrderByNumberApiResponse,
} from './types';
import {
  transformOrderApiResponse,
  getOrderByNumberQueryKey,
  type GetOrderByNumberQueryKeyType,
} from './utils';

export const useGetOrderByNumber: QueryFunction<
  Order,
  [OrderByNumberParams],
  GetOrderByNumberQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getOrderByNumberQueryKey(params);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request<OrderByNumberApiResponse>(
        `/orders/by_number/${params.orderNumber}?group=${params.groupId}`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      ).then(transformOrderApiResponse),
  });
};
